import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import ContactForm from '../../components/crm/ContactForm';

export default function ContactCreate() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return (
    <div className="flex flex-col gap-4 pb-10">
      <ContactForm
        onClose={() => navigate('/crm/contacts')}
        onSaved={(id) => {
          queryClient.invalidateQueries({ queryKey: ['crm-contacts'] });
          navigate(`/crm/contacts/${id}`);
        }}
        standalone
      />
    </div>
  );
}
